import { EVENT_DATE_LABEL } from "../../config/event";
import { Diamond } from "../funnel";

const INCLUDES = [
  "90-minute live masterclass on Zoom",
  "The Clean · Build · Position roadmap",
  "What lenders actually look at before they say yes",
  "Live Q&A: bring your questions about your own file",
];

const Notch = ({ className }) => <span aria-hidden="true" className={`absolute h-7 w-7 rounded-full border border-[rgba(232,184,74,0.35)] bg-[#0a0a0a] ${className}`} />;

export const Ticket = () => (
  <div className="lux-card fade-up relative mt-14 grid w-full max-w-4xl text-left [animation-delay:560ms] md:grid-cols-[1fr_1.35fr]" data-testid="hero-ticket">
    <div className="px-6 py-8 sm:px-10 sm:py-10">
      <p className="font-mono-plex text-[11px] tracking-[0.35em] text-[#bdb4a2]">ADMIT ONE</p>
      <p className="font-display gold-text mt-3 text-[44px] uppercase leading-[0.92] sm:text-6xl" data-testid="ticket-title">COMPLIMENTARY SEAT</p>
      <p className="font-serif-it mt-4 text-xl text-[#efe6d1]" data-testid="ticket-date">{EVENT_DATE_LABEL}</p>
      <p className="mt-5 flex items-center gap-2.5 text-sm font-medium text-[#f1e9d8]" data-testid="ticket-seats">
        <span className="live-dot" aria-hidden="true" />Only 47 live seats
      </p>
    </div>
    <div className="relative border-t border-dashed border-[rgba(232,184,74,0.5)] px-6 py-8 sm:px-10 sm:py-10 md:border-l md:border-t-0">
      <Notch className="-left-[15px] -top-[15px] md:-left-[15px] md:-top-[15px]" />
      <Notch className="-right-[15px] -top-[15px] md:-bottom-[15px] md:-left-[15px] md:right-auto md:top-auto" />
      <p className="font-mono-plex text-[11px] tracking-[0.3em] text-[var(--gold)]">YOUR SEAT INCLUDES</p>
      <ul className="mt-5 space-y-3.5">
        {INCLUDES.map((item) => (
          <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-[#ece4d3]">
            <Diamond className="mt-[3px] text-[11px]" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <p className="font-mono-plex mt-6 text-[11px] tracking-[0.12em] text-[#9d968a]">No cost · No credit pull · No card required</p>
    </div>
  </div>
);
